<template>
  <div class="packs-list">
    <div v-for="pack in packs" :key="pack.id" class="pack-item">
      <PackStoreItem
        :pack-id="pack.id"
        :pack-name="pack.title"
        :description="pack.description"
        :price="pack.price"
        :currency="currency"
        :image-url="pack.image_url"
        :pack-products="pack.items || []"
        @purchase="handlePackPurchase"
      />
    </div>
  </div>
</template>

<script>
import PackStoreItem from './PackStoreItem.vue'

export default {
  name: 'PacksList',

  components: {
    PackStoreItem,
  },

  props: {
    packs: {
      type: Array,
      required: true,
    },

    currency: {
      type: String,
      required: true,
    },
  },

  emits: ['addToCart'],

  methods: {
    handlePackPurchase(data) {
      console.log('PACK PURCHASE:', data)

      this.$emit('addToCart', data, data.packId, 'pack')
    },
  },
}
</script>

<style scoped>
.packs-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  position: relative;
  margin: 32px auto 0;
}

@media (max-width: 768px) {
  .packs-list {
    gap: 16px;
  }
}
</style>
